import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryResultsModel } from '../../_base/crud';
import { TagsState } from '../_reducers/tag.reducers';
import { Tag } from '../_models/tag.model';

export const selectTagsState = createFeatureSelector<TagsState>('tags');

export const selectTagsPageLoading = createSelector(selectTagsState, (tagsState) => {
  return tagsState.listLoading;
});

export const selectTagsInStore = createSelector(selectTagsState, (tagsState) => {
  const items = (tagsState.ids as number[])
    .map((id) => tagsState.entities[id])
    .filter((item): item is Tag => item !== undefined);
  return new QueryResultsModel(items, tagsState.totalCount);
});

export const selectTagsShowInitWaitingMessage = createSelector(
  selectTagsState,
  (tagsState) => tagsState.showInitWaitingMessage,
);

export const selectHasTagsInStore = createSelector(selectTagsState, (queryResult) => {
  return queryResult.totalCount;
});
